import { createContext, useCallback, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { createPost, getPosts, loadConnections, updatePost } from '../firebase/controller/community';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { closeModal, openModal } from '../redux/modal/modalRedux';
import { getAuth } from 'firebase/auth';
import { uploadPost } from '../utils';
const PostContext = createContext();

export function usePost() {
    return useContext(PostContext);
}


export function PostProvider({ children }) {
    
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authStore);
    const [posts, setPosts] = useState([]);
    const [selectedPost, setSelectedPost] = useState({});
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [ groupData, setGroupData] = useState(null);
    const [ uploadedMedia, setUploadedMedia] = useState([]);
    const [ uploadMedia, setUploadMedia] = useState(null);
    const [ taggedConnections, setTaggedConnections] = useState([]);
    const [ myConnections, setMyConnections ] = useState([]);
    const [ loader, setLoader] = useState(false);
    const [values, setValues] = useState();
    const [ newPost, setNewPost] = useState(false);

    const listposts = async () => {
        try {
            setLoading(true);
            const res = await getPosts(posts.length - 1, groupData?.id);
            setPosts(res);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const loadconnections = async () => {
        try {
            setLoading(true);
            const res = await loadConnections();
            setMyConnections(res);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    };


    const createpost = useCallback(
        (status) => {
            if(uploadMedia) {
                uploadPost(uploadMedia, uploadedMedia, setUploadedMedia, setLoader, status, async () => {
                    const data = { ...values, tags: taggedConnections.map((user) => user?.userId), media: uploadedMedia }
                    if (groupData) data['group'] = groupData?.id
                    const res = await createPost(data, setNewPost);
                    res && toast.success("Post created successful.");
                    setDone(true);
                    setLoader(false);
                });
            }
    }, [uploadMedia, uploadedMedia, values, taggedConnections, groupData])

    const getmoreposts = async () => {
        try {
            if (!isEmpty(user)) {
                setLoading(true);
                const res = await getPosts(posts.length - 1, groupData?.id);
                setPosts([...posts, ...res]);
                setLoading(false);
            }
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const updatepost = async () => {
        try {
            setLoading(true);
            const res = await updatePost(selectedPost);
            res && toast.success("post updated successful.");
            setDone(true);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            console.log(message);
            setLoading(false);
        }
    }

    useEffect(() => {
        (async function () {
            if (uploadMedia && uploadedMedia.length === Array.from(uploadMedia).length) {
                await createpost(true);
            }
        })();
    }, [createpost, uploadedMedia.length, uploadMedia]);

    const createwithoutmedia = async () => {
        try {
            setLoader(true);
            const data = { ...values, tags: taggedConnections.map(user => user?.userId) }
            if (groupData) data['group'] = groupData?.id
            const res = await createPost(data, setNewPost);
            res && toast.success("post created successful.");
            setLoader(false);
        } catch (error) {
            console.log(error.message);
            toast.error("There is an error adding claim, try again");
            setLoader(false);
        }
    };

    useEffect(() => {
        if(newPost){
            getmoreposts();
            setNewPost(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newPost, setNewPost])


    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((user) => {
            if (user) {
                listposts();
                loadconnections();
            }
        });
        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupData]);

    useEffect(() => {
        if (loading) dispatch(openModal())
        if (!loading) dispatch(closeModal())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, setLoading])
    
    

    const value ={
        getmoreposts,
        createpost,
        updatepost,
        loader,
        createwithoutmedia,
        uploadedMedia,
        setUploadMedia,
        uploadMedia,
        myConnections,
        taggedConnections,
        setTaggedConnections,
        posts,
        setValues,
        values,
        selectedPost,
        setSelectedPost,
        loading,
        done,
        setGroupData
    }

    return <PostContext.Provider value={value}>{children}</PostContext.Provider>
}